module.exports = __webpack_public_path__ + "static/media/animation.02dd93f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riley_assets/animation.mp4
// module id = ziK2
// module chunks = 1